export const initialState = {
    data: {
        generators: [],
        contacts: [],
    },
    dialogs: {
        deleteConfirm: false,
        addConfirm: false,
        editConfirm: false,
        viewConfirm: false,
        selectedRecord: null,
    },
    forms: {
        addContactForm: {
            generatorCompanyId: "",
            companyId: "",
            firstName: "",
            lastName: "",
            requiredID: false,
            nationalId: "",
            mobileNumber: "",
            address: "",
            email: "",
            type: "",
            other: "",
        },
        editContactForm: {
            generatorCompanyId: "",
            companyId: "",
            firstName: "",
            lastName: "",
            requiredID: false,
            nationalId: "",
            mobileNumber: "",
            address: "",
            email: "",
            type: "",
            other: "",
        },
        viewContactForm: {
            generatorCompanyId: "",
            companyId: "",
            firstName: "",
            lastName: "",
            requiredID: false,
            nationalId: "",
            mobileNumber: "",
            address: "",
            email: "",
            type: "",
            other: "",
        },
        initialEditContactForm: {
            generatorCompanyId: "",
            companyId: "",
            firstName: "",
            lastName: "",
            requiredID: false,
            nationalId: "",
            mobileNumber: "",
            address: "",
            email: "",
            type: "",
            other: "",
        },
    },
    ui: {
        requiredIdOptions: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
        ],
    },
    loading: {
        isLoadingBackdrop: false,
        isBackgroundRefreshing: false,
    },
    table: {
        searchInput: "",
        currentPage: 1,
        recordsPerPage: 10,
    },
};

export function manageContactsReducer(state, action) {
    switch (action.type) {
        case "SET_GENERATORS":
            return {
                ...state,
                data: {
                    ...state.data,
                    generators: action.payload || [],
                },
            };
        case "SET_CONTACTS":
            return {
                ...state,
                data: {
                    ...state.data,
                    contacts: action.payload || [],
                },
            };
        case "OPEN_DELETE_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteConfirm: true,
                    selectedRecord: action.payload,
                },
            };

        case "CLOSE_DELETE_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteConfirm: false,
                    selectedRecord: null,
                },
            };

        case "OPEN_EDIT_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    editConfirm: true,
                    selectedRecord: action.payload.record,
                },
                forms: {
                    ...state.forms,
                    editContactForm: action.payload.editFormData,
                    initialEditContactForm: action.payload.initialEditContactForm ?? action.payload.editFormData,
                },
            };

        case "CLOSE_EDIT_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    editConfirm: false,
                    selectedRecord: null,
                },
                forms: {
                    ...state.forms,
                    editContactForm: initialState.forms.editContactForm,
                    initialEditContactForm: initialState.forms.initialEditContactForm,
                },
            };

        case "OPEN_ADD_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    addConfirm: true,
                },
            };

        case "CLOSE_ADD_DIALOG":
            return {
                ...state,
                forms: {
                    ...state.forms,
                    addContactForm: initialState.forms.addContactForm,
                },
                dialogs: {
                    ...state.dialogs,
                    addConfirm: false,
                },
            };

        case "OPEN_VIEW_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    viewConfirm: true,
                    selectedRecord: action.payload.record,
                },
                forms: {
                    ...state.forms,
                    viewContactForm: action.payload.viewFormData,
                },
            };

        case "CLOSE_VIEW_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    viewConfirm: false,
                    selectedRecord: null,
                },
                forms: {
                    ...state.forms,
                    viewContactForm: initialState.forms.viewContactForm,
                },
            };

        case "UPDATE_FORM_FIELD":
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.payload.formName]: {
                        ...state.forms[action.payload.formName],
                        [action.payload.fieldName]: action.payload.value,
                    },
                },
            };

        case "SET_LOADING":
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.key]: action.payload.value,
                },
            };

        case "SET_SEARCH_INPUT":
            return {
                ...state,
                table: { ...state.table, searchInput: action.payload, currentPage: 1 },
            };

        case "SET_CURRENT_PAGE":
            return {
                ...state,
                table: { ...state.table, currentPage: action.payload },
            };

        default:
            return state;
    }
}
